module.exports = __webpack_public_path__ + "roboto-bolditalic-webfont.65af851bdcd32e890f29.svg";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/fonts/roboto-bolditalic-webfont.svg
// module id = ../../../../../src/assets/fonts/roboto-bolditalic-webfont.svg
// module chunks = styles